import { BaseModel } from '../../../global/models';

export interface UsersSettings extends BaseModel {
  ambassadorSegments: AmbassadorSegment[];
  ambassadorTypes: AmbassadorType[];
  number: string;
}

type AmbassadorType = 'A' | 'B' | 'C';

enum AmbassadorSegment {
  RESIDENCIA = 'Residencia',
  OPOSITORA_MAESTRA = 'Opositora a Maestra',
  UNIVERSITARIA_ENFERMERIA = 'Universitaria Enfermería',
  UNIVERSITARIA_MEDICINA = 'Universitaria Medicina',
  OPOSITOR_MAESTRO = 'Opositor a Maestro',
  OPOSITORA_ADMINISTRACION = 'Opositora Administración',
  OPOSITOR_PROFESOR = 'Opositor a Profesor',
  OPOSITORA_PROFESORA = 'Opositora a Profesora',
  MIR = 'MIR',
  MAESTRA = 'Maestra',
  MAESTRO = 'Maestro',
  OPOSITOR_JUSTICIA = 'Opositor a Justicia',
  OPOSITORA_JUSTICIA = 'Opositora a Justicia',
  PIR = 'PIR',
  BACHILLERATO = 'Bachillerato',
  UNIVERSITARIA_DERECHO = 'Universitaria Derecho',
  OPOSICIONES_GUARDIA_CIVIL = 'Oposiciones Guardia Civil',
  ENFERMERA = 'Enfermera/o',
  UNIVERSITARIA_EDUCACION = 'Universitaria educación',
  UNIVERSITARIA_VETERINARIA = 'Universitaria Veterinaria',
  PSICOLOGA = 'Psicóloga',
  OPOSITOR_POLICIA = 'Opositor Policía',
  UNIVERSITARIA_RRLL_RRHH = 'Universitaria rrll+rrhh',
  FISIOTERAPEUTA = 'Fisioterapeuta',
  EIR = 'EIR',
  ORIENTADOR = 'Orientador',
  FP_FARMACIA = 'FP Farmacia',
  UNIVERSITARIA_ODONTOLOGIA = 'Universitaria Odontología',
  OTROS = 'Otros'
}

